import { assignCommonProperties } from '../util/data/assign-common-properties.js'

import {
	jsonClass,
	jsonProperty,
	jsonArrayProperty,
} from '@sumbricht/json-class-serializer'
import { jsonMapProperty } from '@sumbricht/json-class-serializer'

export const SubsetPropertyAvailabilities = ['', 'y', 'n'] as const
export const SubsetPropertyAvailabilityNames: Record<
	(typeof SubsetPropertyAvailabilities)[number],
	string
> = {
	'': '(default)',
	y: 'Yes',
	n: 'No',
}

@jsonClass('EntitySubset')
export class EntitySubset {
	@jsonProperty() name!: string
	@jsonProperty() parentSubset: string = ''
	@jsonMapProperty(String, String)
	itemAvailability: Map<string, (typeof SubsetPropertyAvailabilities)[number]> =
		new Map()

	constructor(init?: Partial<EntitySubset>) {
		assignCommonProperties(this, init)
	}
}
